module.exports = __webpack_public_path__ + "img/daxdinfo_sample.6d573a5a.png";